var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FmedBoiteConnexion',{attrs:{"chargement":_vm.connecting,"message-erreur":"Erreur lors de la tentative de connexion"},on:{"connexion":_vm.connect}})
}
var staticRenderFns = []

export { render, staticRenderFns }